import { Link } from "react-router-dom";
import { works } from "@/data/catalog";
import { useFavorites } from "@/hooks/useFavorites";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function FavoritesPanel({ open, onClose }: Props) {
  const { favorites, removeFavorite } = useFavorites();
  const saved = works.filter((w) => favorites.includes(w.id));

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={onClose} />
      <div className="absolute top-0 right-0 h-full w-full max-w-md bg-background-50 flex flex-col">
        <div className="h-16 px-5 flex items-center justify-between border-b border-background-200 shrink-0">
          <div className="flex items-center gap-2 text-foreground-950">
            <i className="ri-bookmark-fill text-accent-500" />
            <span className="font-heading font-bold">我的收藏</span>
            <span className="text-sm text-foreground-500">（{saved.length}）</span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
            aria-label="关闭收藏面板"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          {saved.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center gap-3">
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-bookmark-line text-3xl" />
              </span>
              <p className="text-foreground-700 font-medium">还没有收藏任何作品</p>
              <p className="text-sm text-foreground-500 max-w-[15rem]">
                在作品卡片或详情页点击收藏按钮，即可把喜欢的作品保存在这里（仅限当前设备）。
              </p>
            </div>
          ) : (
            <ul className="flex flex-col gap-3">
              {saved.map((item) => (
                <li
                  key={item.id}
                  className="flex gap-3 p-3 rounded-lg border border-background-200 bg-background-100/60"
                >
                  <Link
                    to={`/detail/${item.id}`}
                    onClick={onClose}
                    className="w-16 h-24 shrink-0 rounded-md overflow-hidden bg-background-200"
                  >
                    <img
                      src={item.poster}
                      alt={`${item.title}海报`}
                      title={`${item.title} 韩国伦理影视`}
                      className="w-full h-full object-cover object-top"
                    />
                  </Link>
                  <div className="flex-1 min-w-0">
                    <Link
                      to={`/detail/${item.id}`}
                      onClick={onClose}
                      className="font-medium text-foreground-950 hover:text-primary-700 line-clamp-1"
                    >
                      {item.title}
                    </Link>
                    <p className="text-xs text-foreground-500 mt-1">
                      {item.year} · {item.type === "movie" ? "伦理电影" : "伦理电视剧"}
                    </p>
                    <div className="flex flex-wrap gap-1 mt-1.5">
                      {item.genres.slice(0, 2).map((g) => (
                        <span
                          key={g}
                          className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900"
                        >
                          {g}
                        </span>
                      ))}
                    </div>
                    <button
                      type="button"
                      onClick={() => removeFavorite(item.id)}
                      className="mt-2 text-xs text-foreground-500 hover:text-accent-600 flex items-center gap-1 cursor-pointer"
                    >
                      <i className="ri-delete-bin-6-line" /> 移除收藏
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}